// extracted by mini-css-extract-plugin
export default {"paymentSection":"R7-z"};